import Quotes from "@/assets/svgs/Quotes";
import React from "react";
// import Image from 'next/image';

type HeaderTestimonialProps = {
  data: {
    name: string;
    position: string;
    avatar: string;
    review: string;
  };
};

const HeaderTestimonial: React.FC<HeaderTestimonialProps> = ({ data }) => {
  const { name, position, avatar, review } = data;
  return (
    <div className="relative overflow-hidden rounded-3xl border-[1px] border-solid border-purple-1 bg-grey-1 shadow-[0px_19px_0px_-12px_rgba(137,_132,_255,_0.5)] md:max-w-[400px]">
      <div className="bg-greenLight  absolute -left-12 top-16 z-0 block " />
      <div className="z-10  rounded-2xl bg-white px-11 py-9 shadow lg:h-full lg:max-w-65">
        <h5 className="mb-4 text-title-14">{review}</h5>
        <div className="flex  flex-row items-center lg:flex-row">
          <img
            src={avatar}
            alt={`${name} avatar`}
            height={36}
            width={36}
            className="mr-4 rounded-full lg:block"
          />
          <div>
            <h5 className="mb-1 text-title-14 md:text-sm">{name}</h5>
            <h6 className="text-body-12">{position}</h6>
          </div>
        </div>
      </div>
      <div className="absolute -bottom-2 right-4 z-10">
        <Quotes />
      </div>
    </div>
  );
};
export default HeaderTestimonial;
